import { makeStyles } from '@material-ui/core';

import { colorTheme } from '../../shared/styles/colors';

export default makeStyles({
  root: {
    backgroundColor: colorTheme.brand.primary.light,
  },
});
